export const SEARCH_MOVIES = 'SEARCH_MOVIES';
export const GET_MOVIE = 'GET_MOVIE';
export const CLEAR_MOVIES = 'CLEAR_MOVIES';
export const SHOW_ALERT = 'SHOW_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';
export const SET_LOADING = 'SET_LOADING';
export const ADD_NOMINATION = 'ADD_NOMINATION';
export const CLEAR_NOMINATION = 'CLEAR_NOMINATION';
